import { Flex, Text } from '@chakra-ui/react';
import { faCalendar, faClock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, OutlineCard } from '@morressier/alembic';
import { IGetTransferOfferResponse } from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import MultilineText from 'src/components/MultilineText';
import { formatDate, formatDeadlineDate } from 'src/utils/date';
import { TransferTargetJournalInfo } from '../TargetJournalInfo';
import { ReviewerFeedback } from './ReviewerFeedback';

export const TransferOfferFeedback = ({
  payload,
  currentDeadline,
  submissionContextId
}: {
  payload: IGetTransferOfferResponse;
  currentDeadline: Date | undefined;
  submissionContextId: string;
}) => {
  const {
    dateEntered,
    declineReason,
    transferReason,
    editorComment,
    targetJournals
  } = payload;

  return (
    <Flex flexDirection="column" gap={8}>
      <OutlineCard padding={4} width="100%">
        <Flex flexDirection="column" gap={6}>
          <Text textStyle="headingSection">Transfer Offer</Text>

          <Flex flexDirection="column" gap={2}>
            <Flex flexDirection="row" gap={2} alignItems="center">
              <FontAwesomeIcon icon={faCalendar} />
              Received {formatDate(new Date(dateEntered))}
            </Flex>
            {currentDeadline && (
              <Flex flexDirection="row" gap={2} alignItems="center">
                <FontAwesomeIcon icon={faClock} />
                Deadline {formatDeadlineDate(currentDeadline)}
              </Flex>
            )}
          </Flex>

          {declineReason && (
            <Banner
              variant="attention"
              heading="Transfer Offer Declined"
              content={
                <Flex flexDirection="column" marginTop={1}>
                  <Text fontWeight="semibold">Reason for Declining:</Text>
                  <MultilineText textStyle="" text={declineReason} />
                </Flex>
              }
            />
          )}

          {transferReason && (
            <Flex gap={2} flexDirection={'column'}>
              <Text textStyle="headingGroup">Reason for Transfer</Text>
              <MultilineText textStyle="textBody" text={transferReason} />
            </Flex>
          )}

          <Flex gap={4} flexDirection={'column'}>
            <Text textStyle="headingGroup">Offered Journals</Text>
            {targetJournals.map(journal => (
              <TransferTargetJournalInfo key={journal.id} journal={journal} />
            ))}
          </Flex>

          {editorComment && (
            <Flex gap={2} flexDirection={'column'}>
              <Text textStyle="headingGroup">Comments from the Editor</Text>
              <MultilineText textStyle="textBody" text={editorComment} />
            </Flex>
          )}

          <ReviewerFeedback reviewerFeedback={payload.reviewerFeedback} submissionContextId={submissionContextId} />
        </Flex>
      </OutlineCard>
    </Flex>
  );
};
